document.addEventListener('DOMContentLoaded', () => {
    const mainContent = document.querySelector('#MainContent');

    document.querySelectorAll('.drawer-button').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.stopPropagation();
            toggleDrawer(button.nextElementSibling.closest('.drawer-container'));
        });

        button.nextElementSibling.querySelector('.drawer-overlay').addEventListener('click', (e) => {
            const targetClassList = e.target.classList.value;
          console.log('Clicked element:', e.target);
            console.log('Clicked element classes:', e.target.classList);
          
            if (e.target.classList.contains('drawer-overlay') || e.target.closest('.icon-close')) {
                toggleDrawer(button.nextElementSibling.closest('.drawer-container'));
            }
        });
    });

    document.body.addEventListener('click', (event) => {
        if (!event.target.closest('.drawer-button') && !event.target.closest('.drawer-container')) {
            document.querySelectorAll('.drawer-container.open').forEach((drawerContainer) =>  closeDrawer(drawerContainer));
        }
    });

    const toggleDrawer = (drawerWrapper) => {
        if (!drawerWrapper.classList.contains('open')) {
            closeOtherDrawers(drawerWrapper);
        }
        drawerWrapper.classList.toggle('open');
        mainContent.classList.toggle('drawer-open')
    }

    const closeDrawer = (drawerWrapper) => {
        drawerWrapper.classList.remove('open')
        mainContent.classList.remove('drawer-open')
    };

    const closeOtherDrawers = (currentDrawer) => {
        document.querySelectorAll('.drawer-container.open').forEach((drawerContainer) => {
            if (drawerContainer !== currentDrawer) {
                drawerContainer.classList.remove('open');
            }
            mainContent.classList.remove('drawer-open')
        });
    }
});
